export const LOCALHOST_ENVIRONMENT = window.location.hostname === "localhost" || window.location.hostname.includes("192.168.");
export const DEV_ENVIRONMENT = process.env.NODE_ENV === "development";
export const PROD_ENVIRONMENT = process.env.NODE_ENV === "production";
